import { render, staticRenderFns } from "./BankBillsUploadView.vue?vue&type=template&id=5668be43&"
import script from "./BankBillsUploadView.vue?vue&type=script&lang=js&"
export * from "./BankBillsUploadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports